import * as trackers from '@/constants/trackers';

export default {
  data() {
    return {
      useNullableTracker: true,
    };
  },
  computed: {
    trackerItems() {
      const items = [];
      if (this.useNullableTracker) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(trackers)
        .forEach(key => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.trackers.${trackers[key]}`),
            value: trackers[key],
          });
        });
      return items;
    },
  },
};
